import { ReturnStage } from "../../models/returns/IReturnsApi";
import classNames from "../../utils/classNames";
import { stageLabel } from "../../utils/returnsRules";

interface StageChipProps {
  stage: ReturnStage;
  label?: string | null;
  /** Who moved it there ("Received · <name>"). */
  by?: string | null;
  className?: string;
}

/** Wilma's own stage, outlined so it reads apart from eBay's state. */
export default function StageChip({ stage, label, by, className }: StageChipProps) {
  const text = label || stageLabel(stage);
  return (
    <span className={classNames("whitespace-nowrap rounded border border-gray-200 bg-white px-[7px] py-0.5 text-[11px] text-gray-700", className)}>
      {by ? `${text} · ${by}` : text}
    </span>
  );
}
